import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ApiService } from 'store/api/api.service';
import * as MeasurementResultsActions from './measurement-results.actions';
import { catchComplete } from 'app/utils';

@Injectable()
export class MeasurementResultsEffects {
  constructor(private actions$: Actions, private apiService: ApiService) {}

  loadMeasurementResultsByPage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeasurementResultsActions.loadMeasurementResultsByPage),
      mergeMap((action) =>
        this.apiService
          .getMeasurementResultsByPage(
            {
              from: action.from,
              to: action.to,
              page: action.page,
              page_size: action.pageSize,
            },
            {
              cache: action.cache,
            }
          )
          .pipe(
            map((data) =>
              MeasurementResultsActions.loadMeasurementResultsByPageSuccess({
                results: data.results,
              })
            ),
            catchError((error) =>
              of(MeasurementResultsActions.loadMeasurementResultsByPageFailure({ error }))
            ),
            catchComplete(() =>
              of(MeasurementResultsActions.loadMeasurementResultsByPageComplete({ action }))
            )
          )
      )
    );
  });

  updateMeasurementResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementResultsActions.updateMeasurementResult),
      mergeMap((action) =>
        this.apiService.updateMeasurementResult(action.id, action.note).pipe(
          map((measurementResult) =>
            MeasurementResultsActions.updateMeasurementResultSuccess({ measurementResult })
          ),
          catchError((error) =>
            of(MeasurementResultsActions.updateMeasurementResultFailure({ error }))
          )
        )
      )
    )
  );

  deactivateMeasurementResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementResultsActions.deactivateMeasurementResult),
      mergeMap((action) =>
        this.apiService.deactivateMeasurementResult(action.id, action.reason).pipe(
          map((measurementResult) =>
            MeasurementResultsActions.updateActivationStateMeasurementResultSuccess({
              measurementResult,
            })
          ),
          catchError((error) =>
            of(MeasurementResultsActions.updateActivationStateMeasurementResultFailure({ error }))
          )
        )
      )
    )
  );

  activateMeasurementResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeasurementResultsActions.activateMeasurementResult),
      mergeMap((action) =>
        this.apiService.activateMeasurementResult(action.id).pipe(
          map((measurementResult) =>
            MeasurementResultsActions.updateActivationStateMeasurementResultSuccess({
              measurementResult,
            })
          ),
          catchError((error) =>
            of(MeasurementResultsActions.updateActivationStateMeasurementResultFailure({ error }))
          )
        )
      )
    )
  );
}
